/**
 * Created by or_p on 11/27/2016.
 */
import React from 'react';
import _ from 'lodash';
import fuzzy from 'shared/vendor/fuzzy/src/fuzzy';

export function match(filter, item, searchProps = null, options = {}) {
  const matchStyle = options.matchStyle || `font-weight: 600;`;
  const simpleFilter = _.isString(filter);
  const matchOptions = {
    pre: `<span style="${matchStyle}">`,
    post: '</span>'
  };
  if (searchProps) {
    let newData = 1;
    let first = true;
    if (_.get(filter, 'text') || simpleFilter) {
      newData = _.reduce(searchProps, (newData, searchProp) => {
        const toMatch = simpleFilter ? filter : filter.text;
        const match = toMatch && item && item[searchProp] && fuzzy.match(toMatch, item[searchProp], matchOptions);
        if (match) {
          const highlighted = <span dangerouslySetInnerHTML={{__html: match.rendered}}/>;
          const originalSearchProp = `original${searchProp.charAt(0).toUpperCase() + searchProp.slice(1)}`;
          newData = newData ? {...newData, [originalSearchProp]: item[searchProp], [searchProp]: highlighted} : {...item, [originalSearchProp]: item[searchProp], [searchProp]: highlighted};
          newData.score = Math.max(newData.score || 0, match.score);
          return newData;
        }
        return newData;
      }, false);
    }
    if (simpleFilter || !newData) {
      return newData;
    }
    return _.reduce(searchProps, (newData, searchProp) => {
      if (!newData) {
        return false;
      }
      const toMatch = filter[searchProp];
      if (_.isEmpty(toMatch)) {
        if (_.keys(filter).length === 2) {
          return false;
        }
        return newData;
      }
      const match = toMatch && item && item[searchProp] && fuzzy.match(toMatch, item[searchProp], matchOptions);
      if (match) {
        const highlighted = <span dangerouslySetInnerHTML={{__html: match.rendered}}/>;
        if (first && newData === 1) {
          newData = {...item, [searchProp]: highlighted};
          first = false;
        } else {
          newData = {...newData, [searchProp]: highlighted};
        }
        newData.score = Math.max(newData.score || 0, match.score);
        return newData;
      }
      return false;
    }, newData);
  }
  const match = fuzzy.match(filter, item, {
    pre: `<span style="${matchStyle}">`,
    post: '</span>'
  });
  if (match) {
    return <span dangerouslySetInnerHTML={{__html: match.rendered}}/>;
  }
  return false;
}

export function filter(data, filter, searchProps = null, options = {}) {
  if (!_.isEmpty(filter)) {
    const filteredData = _.isArray(data) ? [] : {};
    _.forEach(data, (item, key) => {
      const newItem = match(filter, item, searchProps, options);
      if (newItem) {
        if (_.isArray(data)) {
          filteredData.push(newItem);
        } else {
          filteredData[key] = newItem;
        }
      }
    });
    if (_.size(filteredData) <= 5 || !_.isArray(filteredData)) {
      return filteredData;
    }
    const scores = _.orderBy(_.map(filteredData, 'score').sort(), _.identity, ['desc']);
    const minScore = _.find(scores, (score, index) => {
      if (!scores[index + 1]) {
        return true;
      }
      return _.filter(filteredData, item => (item.score >= scores[index + 1])).length > 5;
    });
    return _.filter(filteredData, item => (item.score >= minScore || 0));
  }
  return data;
}
